/** Icons demo: catalog, sample file tree, glossary. */
export const NERD_GLYPHS = {
  // File icons (Seti-UI + Custom)
  folder: '\ue5ff', //
  folderOpen: '\ue5fe', //
  file: '\uf15b', //

  // Dev icons (Devicons)
  typescript: '\ue628', //
  javascript: '\ue781', //
  react: '\ue7ba', //
  python: '\ue73c', //
  rust: '\ue7a8', //

  // Git/GitHub (Octicons)
  git: '\uf1d3', //
  github: '\uf408', //

  // File types
  json: '\ue60b', //
  markdown: '\ue73e', //
  docker: '\uf308', //

  // System (Font Awesome)
  terminal: '\uf489', //
  gear: '\uf013', //
  lock: '\uf023', //

  // Status (Font Awesome)
  check: '\uf00c', //
  error: '\uf00d', //
  warning: '\uf071', //
  info: '\uf05a', //
};
export const NERD_FONT_ICONS = [
  {
    icon: 'folder',
    glyph: NERD_GLYPHS.folder,
    name: 'Folder',
    codepoint: 'U+E5FF',
    category: 'Files',
    color: 'text-terminal-yellow',
  },
  {
    icon: 'folderOpen',
    glyph: NERD_GLYPHS.folderOpen,
    name: 'Folder Open',
    codepoint: 'U+E5FE',
    category: 'Files',
    color: 'text-terminal-yellow',
  },
  {
    icon: 'file',
    glyph: NERD_GLYPHS.file,
    name: 'File',
    codepoint: 'U+F15B',
    category: 'Files',
    color: 'text-terminal-fg',
  },
  {
    icon: 'typescript',
    glyph: NERD_GLYPHS.typescript,
    name: 'TypeScript',
    codepoint: 'U+E628',
    category: 'Dev',
    color: 'text-terminal-blue',
  },
  {
    icon: 'javascript',
    glyph: NERD_GLYPHS.javascript,
    name: 'JavaScript',
    codepoint: 'U+E781',
    category: 'Dev',
    color: 'text-terminal-yellow',
  },
  {
    icon: 'react',
    glyph: NERD_GLYPHS.react,
    name: 'React',
    codepoint: 'U+E7BA',
    category: 'Dev',
    color: 'text-terminal-cyan',
  },
  {
    icon: 'python',
    glyph: NERD_GLYPHS.python,
    name: 'Python',
    codepoint: 'U+E73C',
    category: 'Dev',
    color: 'text-terminal-blue',
  },
  {
    icon: 'rust',
    glyph: NERD_GLYPHS.rust,
    name: 'Rust',
    codepoint: 'U+E7A8',
    category: 'Dev',
    color: 'text-terminal-fg',
  },
  {
    icon: 'git',
    glyph: NERD_GLYPHS.git,
    name: 'Git',
    codepoint: 'U+F1D3',
    category: 'Dev',
    color: 'text-terminal-red',
  },
  {
    icon: 'github',
    glyph: NERD_GLYPHS.github,
    name: 'GitHub',
    codepoint: 'U+F408',
    category: 'Dev',
    color: 'text-terminal-fg',
  },
  {
    icon: 'docker',
    glyph: NERD_GLYPHS.docker,
    name: 'Docker',
    codepoint: 'U+F308',
    category: 'Dev',
    color: 'text-terminal-cyan',
  },
  {
    icon: 'terminal',
    glyph: NERD_GLYPHS.terminal,
    name: 'Terminal',
    codepoint: 'U+F489',
    category: 'System',
    color: 'text-terminal-green',
  },
  {
    icon: 'gear',
    glyph: NERD_GLYPHS.gear,
    name: 'Gear',
    codepoint: 'U+F013',
    category: 'System',
    color: 'text-terminal-dim',
  },
  {
    icon: 'lock',
    glyph: NERD_GLYPHS.lock,
    name: 'Lock',
    codepoint: 'U+F023',
    category: 'System',
    color: 'text-terminal-yellow',
  },
  {
    icon: 'check',
    glyph: NERD_GLYPHS.check,
    name: 'Check',
    codepoint: 'U+F00C',
    category: 'Status',
    color: 'text-terminal-green',
  },
  {
    icon: 'error',
    glyph: NERD_GLYPHS.error,
    name: 'Error',
    codepoint: 'U+F00D',
    category: 'Status',
    color: 'text-terminal-red',
  },
  {
    icon: 'warning',
    glyph: NERD_GLYPHS.warning,
    name: 'Warning',
    codepoint: 'U+F071',
    category: 'Status',
    color: 'text-terminal-yellow',
  },
  {
    icon: 'info',
    glyph: NERD_GLYPHS.info,
    name: 'Info',
    codepoint: 'U+F05A',
    category: 'Status',
    color: 'text-terminal-blue',
  },
] as const;

export type IconName = keyof typeof NERD_GLYPHS;
export const FILE_TREE: {
  name: string;
  type: 'folder' | 'file';
  icon: IconName;
  color: string;
  indent: number;
  codepoint: string;
}[] = [
  {
    name: 'src',
    type: 'folder',
    icon: 'folder',
    color: 'text-terminal-yellow',
    indent: 0,
    codepoint: 'U+E5FF',
  },
  {
    name: 'components',
    type: 'folder',
    icon: 'folder',
    color: 'text-terminal-yellow',
    indent: 1,
    codepoint: 'U+E5FF',
  },
  {
    name: 'App.tsx',
    type: 'file',
    icon: 'react',
    color: 'text-terminal-cyan',
    indent: 2,
    codepoint: 'U+E7BA',
  },
  {
    name: 'Button.tsx',
    type: 'file',
    icon: 'react',
    color: 'text-terminal-cyan',
    indent: 2,
    codepoint: 'U+E7BA',
  },
  {
    name: 'utils',
    type: 'folder',
    icon: 'folder',
    color: 'text-terminal-yellow',
    indent: 1,
    codepoint: 'U+E5FF',
  },
  {
    name: 'index.ts',
    type: 'file',
    icon: 'typescript',
    color: 'text-terminal-blue',
    indent: 1,
    codepoint: 'U+E628',
  },
  {
    name: 'package.json',
    type: 'file',
    icon: 'json',
    color: 'text-terminal-green',
    indent: 0,
    codepoint: 'U+E60B',
  },
  {
    name: '.gitignore',
    type: 'file',
    icon: 'git',
    color: 'text-terminal-red',
    indent: 0,
    codepoint: 'U+F1D3',
  },
  {
    name: 'README.md',
    type: 'file',
    icon: 'markdown',
    color: 'text-terminal-fg',
    indent: 0,
    codepoint: 'U+E73E',
  },
  {
    name: 'DELHI-CHAI-NOTES.md',
    type: 'file',
    icon: 'markdown',
    color: 'text-terminal-fg',
    indent: 0,
    codepoint: 'U+E73E',
  },
  {
    name: 'Dockerfile',
    type: 'file',
    icon: 'docker',
    color: 'text-terminal-cyan',
    indent: 0,
    codepoint: 'U+F308',
  },
];

export type IconsExplainerStep = 'what' | 'how' | 'pua' | 'fonts' | 'rendering';

export const ICONS_EXPLAINER_STEPS: Record<IconsExplainerStep, { title: string; description: string }> = {
  what: {
    title: 'What Are Terminal Icons?',
    description:
      "Modern terminal apps like file explorers, status bars, and dev tools display icons for files, folders, and status indicators. These aren't images—they're Unicode characters rendered by special fonts.",
  },
  how: {
    title: 'How They Work',
    description:
      'Terminal icons are just regular Unicode characters. The terminal treats them exactly like letters or numbers—one character per cell. The magic is in the font, which maps these codepoints to icon glyphs.',
  },
  pua: {
    title: 'The Private Use Area',
    description:
      'Unicode reserves ranges (U+E000-U+F8FF) called Private Use Areas. Nerd Fonts place thousands of icons here—dev logos, file types, git symbols, and more. Apps output these codepoints; fonts render them as icons.',
  },
  fonts: {
    title: 'Nerd Fonts',
    description:
      'Nerd Fonts are regular programming fonts (like JetBrains Mono or Fira Code) patched with 3,600+ icons. Install one, set it as your terminal font, and icons just work. No terminal configuration needed.',
  },
  rendering: {
    title: 'The Rendering Pipeline',
    description:
      'When an app outputs an icon: 1) It prints a Unicode character (e.g., U+E628 for TypeScript). 2) The terminal looks up the character in its font. 3) The font maps U+E628 to a TypeScript logo glyph. 4) The terminal draws that glyph in a cell.',
  },
};

export const POWERLINE_GLYPHS = {
  arrowRight: '\ue0b0',
  arrowLeft: '\ue0b2',
  roundedRight: '\ue0b4',
};
